export default "__VITE_ASSET__3b2e0705__"